import { inject } from "@angular/core"
import { StepsService } from '../services/steps.service';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

export const CanActivateGuard = (route: ActivatedRouteSnapshot): boolean => {
    const stepsService = inject(StepsService)
    const router = inject(Router)
    const targetStep = stepsService.getStepByUrl(route.routeConfig!.path!)
    if (targetStep?.disabled) {
        router.navigateByUrl(stepsService.getLastEnabledStepUrl())
        return false
    }
    return true
}
